import type { LoggerInterface } from './types'


const logger: LoggerInterface = (() => {
  if (__TEST__) {
    return require('./testLogger').default
  }
  else if (__SERVER__) {
    return require('./serverLogger').default
  }

  return require('./clientLogger').default
})()


export default logger
